// src/redux/slices/questionSlice.ts

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFreeFormAPI } from "@/services/api/freeForm";

export const fetchFreForm = createAsyncThunk(
  "questions/fetchQuestions",
  async (
    {
      pageNo = 1,
      perPage = 10,
      search = "",
      difficultyLevel = "",
    }: { pageNo?: number; perPage?: number; search?: string; difficultyLevel?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await fetchFreeFormAPI(pageNo, perPage, search, difficultyLevel);
      return {
        results: response?.data?.results || [],
        totalRecord: response?.data?.totalRecord || 0,
      };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Error fetching questions"
      );
    }
  }
);

// export const fetchQuestionsByTags = createAsyncThunk(
//   "questions/fetchQuestionsByTags",
//   async (
//     {
//       pageNo = 1,
//       perPage = 10,
//     }: { pageNo?: number; perPage?: number },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await fetchQuestionsByTagsAPI(pageNo, perPage);
//       return response?.data?.results || [];
//     } catch (error: any) {
//       return rejectWithValue(
//         error.response?.data || "Error fetching questions"
//       );
//     }
//   }
// );

const freeFormSlice = createSlice({
  name: "freeForm",
  initialState: {
    freeForm: [] as any[],
    totalRecords: 0,
    // questionTags: [] as any[],
    loading: false,
    error: null as string | null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchFreForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFreForm.fulfilled, (state, action) => {
        state.loading = false;
        state.freeForm = action.payload.results;
        state.totalRecords = action.payload.totalRecord;

        console.log("Questions:", action.payload);
      })
      .addCase(fetchFreForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default freeFormSlice.reducer;